import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';

interface Props {
	onSuccess: (value: string) => void;
	defaultValues?: { name: string };
}

const formScheme: ItemScheme[] = [
	{
		key: 'name',
		title: 'component.laboratoryRequestTemplateNameForm.name',
		type: MagicField.TEXT_FIELD,
		settings: {
			required: true,
		},
	},
];

const LaboratoryRequestTemplateNameForm: React.FC<Props> = ({
	onSuccess,
	defaultValues,
}) => {
	const handleSubmit = (values: { name: string }) => {
		onSuccess(values.name);
	};

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={defaultValues}
		/>
	);
};

export default LaboratoryRequestTemplateNameForm;
